import PropTypes from 'prop-types';

export default function Header({ heading = '', sideContent = null }) {
	return (
		<header className="prc-header">
			<h6>{heading}</h6>
			<div className="header-extra">{sideContent}</div>
		</header>
	);
}

Header.propTypes = {
	heading: PropTypes.string,
	sideContent: PropTypes.node,
};
